import { render, staticRenderFns } from "./DPlayerSettingQuality.vue?vue&type=template&id=15c177c0&scoped=true&"
import script from "./DPlayerSettingQuality.vue?vue&type=script&lang=js&"
export * from "./DPlayerSettingQuality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c177c0",
  null
  
)

export default component.exports